import { KinesisTracker } from '@yanolja-rnd/ya-tracker';

/** 로그메타를 직접 받는 함수
 * @param method - 클라이언트 로그 메소드
 * @param pageName - 페이지 이름
 * @param logMeta - 로그 메타
 * @param showLog - 로그를 찍을지 여부 - 기본적으로는 true지만, prod 환경에서는 false
 * */
export const clientLogBy = <T extends Record<string, unknown> | null>(
  method: 'click' | 'impression' | 'view' | 'resume',
  pageName: string,
  logMeta?: T,
  showLog = true,
) => {
  const _showLog = showLog && process.env.NEXT_PUBLIC_SERVICE_ENV !== 'prod';
  if (!logMeta) {
    if (!_showLog) {
      return;
    }
    console.error('logMeta is not found');
    return;
  }
  if (!pageName) {
    if (!_showLog) {
      return;
    }
    console.error('pageName is not found');
    return;
  }
  // local 환경에서만 console.log 찍기
  if (_showLog) {
    console.log('logMeta', { method, pageName }, logMeta);
  }

  return KinesisTracker[method](pageName, logMeta);
};

/**
 * pageName 을 수정하는 로직이 포함되어 있습니다.
 * 홈, 서브홈 외에는 사용하지 않기를 권장합니다.
 */
export const clientLogStandardized = <T extends Record<string, unknown> | null>(
  method: 'click' | 'impression' | 'view' | 'resume',
  pageName: string,
  logMeta?: T,
  showLog = true,
) => {
  const _showLog = showLog && process.env.NEXT_PUBLIC_SERVICE_ENV !== 'prod';
  if (!logMeta) {
    if (!_showLog) {
      return;
    }
    console.error('logMeta is not found');
    return;
  }
  if (!pageName) {
    if (!_showLog) {
      return;
    }
    console.error('pageName is not found');
    return;
  }

  // local 환경에서만 console.log 찍기
  if (_showLog) {
    console.log('logMeta', { method, pageName }, logMeta);
  }

  return KinesisTracker[method](pageName, logMeta);
};

/** protobuf 로그를 호출하는 함수
 * @param fn - protobuf 로그 메소드
 * @param logMeta - 로그 메타
 */
export const clientLogProtobuf =
  <T>(fn: (arg: T) => void, logMeta?: T): (() => void) =>
  () => {
    if (!logMeta) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(`protobuf-log not found\n${fn.toString()}`);
      }
      return;
    }

    if (process.env.NODE_ENV !== 'production' && process.env.NEXT_PUBLIC_ENABLE_CLIENT_LOG) {
      if ((process.env.NEXT_PUBLIC_SERVICE_ENV as unknown) === 'local') {
        const stack = new Error().stack?.split('\n').slice(2); // 현재 함수 호출을 제외
        stack?.length && console.log('📌Caller:', stack[0].trim());
      }
      console.log('protobuf-log', fn.name, logMeta);
    }

    fn(logMeta);
  };
